module.exports = __webpack_public_path__ + "static/media/rumen.7e92e2c6.jpg";